<template>
    <div class="panel panel-default panel-dashboard">
        <loading-spinner v-if="data === null"/>

        <div v-else class="panel-body text-center">
            <div class="row">
                <div class="col-xs-6" style="border-right: 1px solid #e1e0e0">
                    <p style="font-size: 36px; margin-bottom: 0">
                        {{ data.closed_count }} / {{ data.total_count }}
                    </p>

                    <p style="margin-bottom: 0">
                        Opportunities
                    </p>
                </div>

                <div class="col-xs-6" style="border-right: 1px solid #e1e0e0">
                    <p style="font-size: 36px; margin-bottom: 0">
                        {{ data.converted_count }} <small style="font-size: 24px;">{{ conversionRate }} %</small>
                    </p>

                    <p style="margin-bottom: 0">
                        Conversions
                    </p>
                </div>

                <div class="col-xs-6" style="border-right: 1px solid #e1e0e0">
                    <p style="font-size: 36px; margin-bottom: 0">
                        {{ data[selectedMetrics.first] | price }}
                    </p>

                    <p style="margin-bottom: 0">
                        {{ metrics.find(metric => metric.value === selectedMetrics.first).label }}
                    </p>
                </div>

                <div class="col-xs-6" style="border-right: 1px solid #e1e0e0">
                    <p style="font-size: 36px; margin-bottom: 0">
                        {{ data[selectedMetrics.second] | price }}
                    </p>

                    <p style="margin-bottom: 0">
                        {{ metrics.find(metric => metric.value === selectedMetrics.second).label }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import LoadingSpinner from '@/components/Layout/LoadingSpinner'

    export default {
        components: {LoadingSpinner},

        props: {
            filters: {
                required: true,
                type: Object
            },

            selectedMetrics: {
                required: true,
                type: Object
            },

            metrics: {
                required: true,
                type: Array
            }
        },

        data() {
            return {
                data: null
            }
        },

        mounted() {
            this.load()
        },

        watch: {
            filters: {
                deep: true,
                handler: function () {
                    this.load()
                }
            }
        },

        computed: {
            conversionRate() {
                if (this.data.closed_count === 0) {
                    return 'N/A'
                }

                return Math.round(this.data.converted_count / this.data.closed_count * 100)
            }
        },

        methods: {
            load() {
                http.post('/api/v1/reports/opportunity-overview', this.filters)
                    .then(response => {
                        this.data = response.data.data
                    })
            }
        }
    }
</script>
